import React from 'react'
import '../App.scss'
import Mainleft from './cardsComponent/Mainleft'


const Leftside = () => {
    return (
        <div className= "leftside">
     
            <div className="headerr">
           <h1>GND CRYPTO</h1> 
           </div>
           < Mainleft />
        </div>
    )
}

export default Leftside;
